import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import FlashAlert from '../flash-alert'
import { postForm, patchForm } from '../../ajax'
import CheckboxWrapper from './checkbox-wrapper'

export default function PlayerModal({name, form, types, setLoading}) {
  const { register, reset, handleSubmit, setValue } = useForm({})
  const [alert, setAlert] = useState(null)
  const [payload, setPayload] = useState(null)
  const [showList, setShowList] = useState(form.enabled)

  useEffect(() => {
    initForm(form)
  }, [])

  const initForm = (data) => {
    setPayload(data)
    reset(_.omit(data, 'id'))
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    for (const key in data) {
      if (key == 'config') 
        formData.append(`auto_message[${key}]`, JSON.stringify(data[key]))
      else
       formData.append(`auto_message[${key}]`, data[key])
    }
    return formData
  }
  
  const onSubmit = (data) => {
    setLoading(true)
    const isNew = !payload.id
    const formMethod = isNew ? postForm : patchForm
    const submitUrl = isNew ? '/admins/auto_messages.json' : `/admins/auto_messages/${payload.id}.json?`
    const formData = prepareFormData(data)

    formMethod(submitUrl, formData)
    .then(response => { return response.json() })
    .then((json) => {
      setLoading(false)
      setAlert(json.alert)
      initForm(json.form)
    })
  }

  return <div className='auto-message-form'>
    { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
    <h4>{name}</h4>
    <form className='form-horizontal' onSubmit={handleSubmit(onSubmit)}>
      <CheckboxWrapper
        {...register('enabled')}
        label={'Send automated messages via ' + name}
        onChange={(e) => {
          setValue('enabled', e.target.checked)
          setShowList(e.target.checked)
        }}
      />
      <div className='types-list'>
        {showList &&
          Object.keys(types).map(key =>
            <CheckboxWrapper
              key={key}
              {...register(`config[${key}]`)}
              label={types[key]}
              onChange={(e) => setValue(`config[${key}]`, e.target.checked)}
            />
          )
        }
      </div>
      <input
        type='submit'
        value='Update'
        className='btn btn-primary'
      />
    </form>
  </div>
}
